const debugModeFlag = "ENABLE_DEBUG_MODE";
const debugModeBaseObject = "debug";

function getDebugContainer() {
  if (!window[debugModeBaseObject]) window[debugModeBaseObject] = {};
  return window[debugModeBaseObject];
}

export function exposeMethodInDebugMode(key: string, fn: Function) {
  if (!window[debugModeFlag]) return;
  getDebugContainer()[key] = fn;
}

export function exposePropertyInDebugMode(key: string, descriptor: PropertyDescriptor) {
  if (!window[debugModeFlag]) return;
  Object.defineProperty(getDebugContainer(), key, descriptor);
}
